import { render, staticRenderFns } from "./ExchangeExamQuestions.vue?vue&type=template&id=29e7d00d&"
import script from "./ExchangeExamQuestions.vue?vue&type=script&lang=js&"
export * from "./ExchangeExamQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeExamQuestions.vue?vue&type=style&index=0&id=29e7d00d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports